<template>
  <v-card>
    <ac-data-table
      ref="table"
      :headers="headers"
      :items.sync="items"
      :item-class="row_class"
      sort-by="level"
      item-key="uid"
      hide-default-footer
      disable-pagination
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Levels"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Config
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>
          mdi-content-copy
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>
    <r-level-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {LevelConfig} from "@/modules/redactor/models/level/LevelConfig";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import RLevelDialog from "@/modules/redactor/views/level/r-level-dialog";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";


export default {
  name: "r-level-page",
  components: {RDialogPreviewCollection, AcDataTable, RLevelDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Level", value: "level"},
      {text: "Experience", value: "experience.string"},
      {text: "Energy capacity", value: "energyCapacity"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(LevelConfig)
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {
            RedactorUtils.pushLevel(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            RedactorUtils.pushLevel(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushLevel(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkLevels(items);
    },

    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, LevelConfig, "level")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getLevels();
  }
}
</script>